/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

export const Container = styled.div`
  padding: 0;
  background: transparent;

  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;
    gap: 24px;

    .page-title {
      font-size: 28px;
      font-weight: bold;
      color: ${({ theme }) => theme.primaryDark};
      margin: 0 0 8px 0;
    }

    .page-subtitle {
      font-size: 14px;
      color: ${({ theme }) => theme.primary70};
      margin: 0;
    }

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: stretch;
    }
  }

  .content-layout {
    padding: 0 20px 20px;
    display: grid;
    grid-template-columns: 1fr 1.2fr;
    gap: 24px;
    align-items: start;

    @media (max-width: 1200px) {
      grid-template-columns: 1fr;
    }
  }

  .group-list-section,
  .group-detail-section {
    height: calc(100vh - 350px);
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .group-list-card,
  .group-detail-card {
    flex: 1;
    display: flex;
    flex-direction: column;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border-radius: 12px;

    .ant-card-body {
      flex: 1;
      overflow: auto;
      padding: 0;
    }

    .ant-table-wrapper {
      height: 100%;
    }

    .ant-table {
      font-size: 14px;
    }

    .ant-table-thead > tr > th {
      background: ${({ theme }) => theme.primaryLight};
      font-weight: 600;
      padding: 16px;
    }

    .ant-table-tbody > tr > td {
      padding: 16px;
    }

    .ant-table-tbody > tr:hover > td {
      background: ${({ theme }) => theme.primaryLight}20;
    }

    .ant-table-tbody > tr.selected-row > td {
      background: #f0f7f0 !important;
      font-weight: 500;
    }

    .ant-table-tbody > tr.selected-row > td:first-child {
      border-left: 3px solid #547756;
    }

    .ant-table-tbody > tr.selected-row:hover > td {
      background: #e0ede0 !important;
    }
  }

  /* Modal styles */
  .ant-modal-body {
    padding-top: 24px;
  }

  .ant-form-item {
    margin-bottom: 20px;
  }

  .ant-form-item-label > label {
    font-weight: 500;
    font-size: 14px;
  }

  /* Badge styles */
  .ant-badge-count {
    font-weight: 600;
  }

  /* Empty state */
  .ant-empty {
    padding: 60px 0;
  }
`;

